__turbopack_context__.v({
  "themeToggle": "index-module__kORJoq__themeToggle",
});
